import { render, staticRenderFns } from "./JImageCarousel.vue?vue&type=template&id=4e3acc39"
import script from "./JImageCarousel.vue?vue&type=script&lang=ts"
export * from "./JImageCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports